import React, { useState, memo } from 'react';

import { App, Checkbox, Input, Modal } from 'antd';

import type { IAffiliate } from 'v2/interfaces/affiliate';
import affiliateService from 'v2/services/affiliate';

interface IProps {
  closeModal: (...args: any[]) => any;
  active: boolean;
  affiliatesSelected: Array<IAffiliate>;
}

const ModalNewMessage = ({ closeModal, active, affiliatesSelected }: IProps) => {
  const { message: feedback } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [sendEmail, setSendEmail] = useState(false);

  const handleClickNew = () => {
    if (!message) {
      feedback.info('Escreva sua mensagem');
      return;
    }

    setLoading(true);

    const affiliates = affiliatesSelected.map(a => a.affiliate_id);

    affiliateService.sendMessageBroadcast(message, affiliates, sendEmail).subscribe(
      () => {
        feedback.success('Mensagem enviada com sucesso');
        setLoading(false);
        setMessage('');
        setSendEmail(false);
        closeModal();
      },
      err => {
        feedback.error(typeof err === 'string' ? err : 'Não foi possível enviar a mensagem.');
        setLoading(false);
      }
    );
  };

  const handleChangeMessage = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const handleChangeSendEmail = (e: any) => {
    setSendEmail(e.target.checked);
  };

  if (!active) {
    return null;
  }

  return (
    <Modal
      open={active}
      title='Nova mensagem para afiliados'
      onCancel={closeModal}
      okText='Enviar'
      cancelText='Cancelar'
      cancelButtonProps={{ type: 'text' }}
      onOk={handleClickNew}
      confirmLoading={loading}
    >
      <div className='flex flex-col gap-3'>
        <label htmlFor='affiliate-message'>Texto da mensagem</label>
        <Input.TextArea id='affiliate-message' rows={4} onChange={handleChangeMessage} value={message} />
        <Checkbox checked={sendEmail} onChange={handleChangeSendEmail}>
          Enviar cópia por e-mail
        </Checkbox>
      </div>
    </Modal>
  );
};

export default memo(ModalNewMessage);
